export default "__VITE_ASSET__CI$VEpzw__"